import {
  MYPAGE_LOGIN_REQUEST,
  MYPAGE_LOGIN_REQUEST_SUCCESS,
  MYPAGE_LOGIN_REQUEST_FAIL
} from "constants/action-types";

const initialState = {
  token: "",
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MYPAGE_LOGIN_REQUEST:
      return initialState;

    case MYPAGE_LOGIN_REQUEST_SUCCESS:
      return {
        ...initialState,
        token: action.payload.data.jwt
      };

    case MYPAGE_LOGIN_REQUEST_FAIL:
      return {
        ...initialState,
        error: action.error.response
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mypage/login.js